import { CommonModule } from "@angular/common";
import { DropdownAlertDefaultTemplateComponent } from "./alert-default-templates/dropdown-alert-default-template.component";
import { DropdownAlertTypeComponent } from "./alert-type/dropdown-alert-type.component";
import { DropdownBulkOrdersComponent } from "./orders-bulk/dropdown-orders-bulk.component";
import { DropdownCompanyComponent } from "./company/dropdown-company.component";
import { DropdownCountryDiallingCodeComponent } from "./country-dialling-code/dropdown-country-dialling-code.component";
import { DropdownDateComponent } from "./date/dropdown-date.component";
import { DropdownDateMonthComponent } from "./date-month/dropdown-date-month.component";
import { DropdownDeviceComponent } from "./device/dropdown-device.component";
import { DropdownFinancialReportsComponent } from "./financial-reports/dropdown-financial-reports.component";
import { DropdownLicenceTypeComponent } from "./licence-type/dropdown-licence-type.component";
import { DropdownUserComponent } from "./user/dropdown-user.component";
import { FlatpickrModule } from "angularx-flatpickr";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { SharedModule } from "src/app/shared/shared.module";
import { ToastsContainer } from "src/app/shared/toast/toasts-container.component";

@NgModule({
  declarations: [
    DropdownAlertDefaultTemplateComponent,
    DropdownAlertTypeComponent,
    DropdownBulkOrdersComponent,
    DropdownCompanyComponent,
    DropdownCountryDiallingCodeComponent,
    DropdownDateComponent,
    DropdownDateMonthComponent,
    DropdownDeviceComponent,
    DropdownFinancialReportsComponent,
    DropdownLicenceTypeComponent,
    DropdownUserComponent
  ],
  imports: [
    CommonModule,
    FlatpickrModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    SharedModule,
    ToastsContainer
  ],
  exports: [
    DropdownAlertDefaultTemplateComponent,
    DropdownAlertTypeComponent,
    DropdownBulkOrdersComponent,
    DropdownCompanyComponent,
    DropdownCountryDiallingCodeComponent,
    DropdownDateComponent,
    DropdownDateMonthComponent,
    DropdownDeviceComponent,
    DropdownFinancialReportsComponent,
    DropdownLicenceTypeComponent,
    DropdownUserComponent
  ],
  providers: [
  ],
  schemas: [
  ]
})

export class DropdownsModule {
  constructor() { }
}
